import React, { Component } from "react";
import ContactForm from "./ContactForm";

class ContactTwo extends Component {
    render(){
        return(
            <div className="contact-form--1" style={{paddingBottom: '15rem'}}>
                <div className="container">
                    <div className="row row--35 align-items-start">
                        <div className="col-lg-6 order-2 order-lg-1">
                            <div className="section-title text-left mb--50">
                                <h2 className="title">Contact Me</h2>
                                <p className="description">Email: <a href="mailto:pgfxx1@gmail.com" style={{ color: '#61baea'}}> pgfxx1@gmail.com</a></p>
                                <p className="description">Message: <a href="https://www.linkedin.com/in/patrickfeliciano/" style={{color: '#9CE17E'}}> DM by LinkedIn</a></p>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        )
    }
}
export default ContactTwo;